export const errorMessageTranslation = {
  fi: {
    ErrorMessage: {
      licenseExpired: 'Lisenssi ei ole voimassa',
    },
  },
};
